module.exports = __webpack_public_path__ + "static/img/i100.80567360.jpeg";